/* unplugin-vue-components disabled */import { render } from "./artistSyno.vue?vue&type=template&id=5414b34e&scoped=true&ts=true"
import script from "./artistSyno.vue?vue&type=script&lang=ts"
export * from "./artistSyno.vue?vue&type=script&lang=ts"

import "./artistSyno.vue?vue&type=style&index=0&id=5414b34e&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5414b34e"],['__file',"src/views/artistDetail/cpns/artistSyno.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5414b34e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5414b34e', __exports__)) {
    console.log('reload')
    api.reload('5414b34e', __exports__)
  }
  
  module.hot.accept("./artistSyno.vue?vue&type=template&id=5414b34e&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('5414b34e', render)
  })

}


export default __exports__